import { render, staticRenderFns } from "./activeInfo.vue?vue&type=template&id=c7c2fc14&scoped=true&"
import script from "./activeInfo.vue?vue&type=script&lang=js&"
export * from "./activeInfo.vue?vue&type=script&lang=js&"
import style0 from "./activeInfo.vue?vue&type=style&index=0&id=c7c2fc14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c2fc14",
  null
  
)

export default component.exports